import InfoBox from '@app/features/order/components/InfoBox'
import { Flex } from '@lokalise/louis'

type TranslationOrderSummaryViewProps = {
  selectedLanguagesCount: number
}

const TranslationOrderSummary = ({ selectedLanguagesCount }: TranslationOrderSummaryViewProps) => {
  // Wrapped in flex to make the InfoBox width as much as it needs, but not more
  const message = selectedLanguagesCount
    ? 'No words in target language.'
    : 'Select target languages to get an instant quote.'

  return (
    <Flex>
      <InfoBox title={message} />
    </Flex>
  )
}

export default TranslationOrderSummary
